<script setup>
  import { useMapUIStore } from "@/stores/MapUIStore";
  const mapUIStore = useMapUIStore();
</script>
<template>
  <Teleport to=".map-container">
    <Transition>
    <div v-show="mapUIStore.showLegend" class="jwx-map-legend" data-map="legend"></div>
  </Transition>
  </Teleport>
</template>